import { render, staticRenderFns } from "./IconHighChance.vue?vue&type=template&id=ad7c4012&"
import script from "./IconHighChance.vue?vue&type=script&lang=ts&"
export * from "./IconHighChance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports